
<template lang="pug">
  div(style="")
    slot
    center
      div(class="border")
          img(src="@/assets/login_logo.png")
      
      //img(src="@/assets/login_logo.png" width="150px")
    

    el-form(ref='form' :rules="rules" label-position="top" :model='form')
      // el-form-item(label='工號' prop="id" required)
        el-input(v-model='form.id' disabled)
      el-form-item(label='手機號碼：' prop="userTel" )
        el-input(v-model='form.userTel' type="tel"  maxlength="10" placeholder="請輸入您的手機號碼" width="100%")

    

    p
    p
    p
    center(style="margin-top: 10px;")
        el-button(class="full" type="primary"  @click="submit" width="100%") 登入會員
    p
    p
    p 
    center or
    p
    p
    p
    center 尚未加入會員？請點擊
      span( @click="$router.push({ name: 'JoinInfo' })") 
       a(href="#") 加入會員
    p
    center() ＊ 市話用戶請直接
      a(href="https://line.me/R/ti/p/4qEAShuHxJ" target="_blank") 連繫客服
      // el-button(type="primary" @click="$router.push({ name: 'JoinInfo' })" width="100%") 加入會員

    p
    p
    hr
    p
    center
      a(class="add-button ht-header-bttn ht-mobile-hide" size="mini" type="primary" @click="add_to_home()") 新增至主畫面
    p
    p
    p 
    
    
</template>

<script>
import Cookies from 'js-cookie'
import { login } from '@/api/user'
// 驗證
const phoneValidator = (rule, value, callback) => {
  // mail驗證方式 https://ithelp.ithome.com.tw/articles/10094951
  const phoneRule = /^[09]{2}[0-9]{8}$/
  if (value.length === 0) {
    callback(new Error('請輸入手機號碼'))
  } else if (value.search(phoneRule) === -1) {
    callback(new Error('請輸入正確手機格式'))
  } else {
    callback()
  }
}
export default {
  name: 'LoginLndex',
  props: {
    userTel: {
      type: String
    }
  },
  data () {
    return {
      form: {
        userTel: '',
      },
      rules: {
        userTel: [{ required: true, validator: phoneValidator, trigger: 'change' }],
      },
    }
  },
  created() {
    let phone = Cookies.get('phone');
    console.log("Cookies.get('phone')", phone)
    if(phone){
      this.$router.replace({ name: 'info' })
    }else{
      this.$router.replace({ path: '/user/login/index' })
    }
  },
  mounted() {
      this.add_to_home();
  },
  methods: {
    submit () {
      //驗證
      this.$refs['form'].validate(valid => {
        if (!valid) return false
        login({userTel: this.form.userTel}).then(res=>{
          if(res.data.status !== 0){
            this.$alert("該手機非易立洗會員，請先註冊會員，才能使用預約服務", {confirmButtonText: '確認',
            callback: action => {
              // this.$router.push({ name: 'entry' })
              this.$router.push({name: 'JoinInfo', params: {phone_number: this.form.userTel}})
              
              
            }} )
          }else{
            console.log(this.$route)
            this.$emit('setUserTel', this.form.userTel)
            this.$router.push({ name: 'LoginVerification' })
          }
        })
      })



      
      
    },
    add_to_home() {
      let deferredPrompt;
      const addBtn = document.querySelector('.add-button');
      window.addEventListener('beforeinstallprompt', (e) => {
        // Prevent Chrome 67 and earlier from automatically showing the prompt
        e.preventDefault();
        // Stash the event so it can be triggered later.
        deferredPrompt = e;
        // Update UI to notify the user they can add to home screen
        addBtn.addEventListener('click', (e) => {
          addToHomescreen();
          // hide our user interface that shows our A2HS button
          // addBtn.style.display = 'none';
          // Show the prompt
          deferredPrompt.prompt();
          // Wait for the user to respond to the prompt
          deferredPrompt.userChoice.then((choiceResult) => {
              if (choiceResult.outcome === 'accepted') {
                console.log('User accepted the A2HS prompt');
              } else {
                console.log('User dismissed the A2HS prompt');
              }
              deferredPrompt = null;
            });
        });
      });
    }
  },
}
</script>

<style scoped>
@media (min-width: 900px) {
  .el-form-item {
      margin: 0 6vw;
  }
}
</style>
<style>
a {
    color:#007bff;
}
.el-button.full {
  width: 100%
}

@media (min-width: 600px) {
.el-button.full {
  width: 50%
}

}

.border{
  width: 150px;
  position: relative;
    border: 4px solid transparent;
    border-radius: 16px;
    background: linear-gradient(white, white);
    background-clip: padding-box;
    padding: 10px;
    /* just to show box-shadow still works fine */
    box-shadow: 0 3px 9px black, inset 0 0 9px white;
    margin-bottom: 20px;
}
.border::after{
    position: absolute;
    top: -4px; bottom: -4px;
    left: -4px; right: -4px;
    content: '';
    z-index: -1;
    border-radius: 16px;
}
</style>
